import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: 8,
		marginTop: 8,
	},
});
